import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './BlogList.css';

class BlogList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
      selectedCategory: 'All',
      selectedTag: '',
      emailInput: '',
      subscribed: false
    };
  }

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  handleCategorySelect = (category) => {
    this.setState({ selectedCategory: category });
  };

  handleTagSelect = (tag) => {
    this.setState({ selectedTag: this.state.selectedTag === tag ? '' : tag });
  };

  handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (this.state.emailInput.trim()) {
      this.setState({ subscribed: true, emailInput: '' });
      setTimeout(() => this.setState({ subscribed: false }), 4000);
    }
  };

  render() {
    const { searchQuery, selectedCategory, selectedTag, emailInput, subscribed } = this.state;

    const categories = [
      { name: 'All', count: 24 },
      { name: 'Destination Guides', count: 8 },
      { name: 'Travel Tips', count: 6 },
      { name: 'Luxury Stays', count: 5 },
      { name: 'Budget Travel', count: 3 },
      { name: 'Food & Culture', count: 2 }
    ];

    const popularTags = ['Hotels', 'Beach', 'City Breaks', 'Luxury Villas', 'Packing Tips', 'Solo Travel', 'Europe', 'Resorts'];

    const featuredPost = {
      id: 1,
      title: '10 Hidden Luxury Villas in Bali You Need to Experience in 2026',
      excerpt: 'Escape the tourist crowds with our handpicked guide to secluded private pool villas, serene jungle retreats, and cliffside ocean views across the Island of the Gods.',
      category: 'Luxury Stays',
      image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?auto=format&fit=crop&q=80&w=1200',
      author: 'Sophia Reynolds',
      authorAvatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=200',
      date: 'Aug 1, 2026',
      readTime: '6 min read',
      views: '2.4k'
    };

    const blogPosts = [
      {
        id: 2,
        title: 'The Ultimate Guide to Finding Boutique Hotels in Paris',
        excerpt: 'Discover charming, artfully designed boutique stays hidden in Le Marais and Saint-Germain-des-Prés that offer authentic Parisian elegance.',
        category: 'Destination Guides',
        image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&q=80&w=800',
        author: 'Julian Vance',
        authorAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200',
        date: 'Jul 28, 2026',
        readTime: '5 min read',
        views: '1.8k'
      },
      {
        id: 3,
        title: 'How to Score Up to 40% Off Premium Hotel Bookings',
        excerpt: 'Insider booking hacks, timing strategies, and secret loyalty perks that travel agents use to unlock luxury accommodations for less.',
        category: 'Travel Tips',
        image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&q=80&w=800',
        author: 'Elena Rostova',
        authorAvatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&q=80&w=200',
        date: 'Jul 22, 2026',
        readTime: '4 min read',
        views: '3.1k'
      },
      {
        id: 4,
        title: 'Tokyo Foodie Trajectory: Where to Stay for Michelin Stays',
        excerpt: 'A curated itinerary combining five-star luxury accommodations with walking access to Ginza and Shibuya’s finest culinary secrets.',
        category: 'Food & Culture',
        image: 'https://images.unsplash.com/photo-1503899036084-c55cdd92da26?auto=format&fit=crop&q=80&w=800',
        author: 'Marcus Chen',
        authorAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=200',
        date: 'Jul 18, 2026',
        readTime: '8 min read',
        views: '1.2k'
      },
      {
        id: 5,
        title: 'Sustainable Hospitality: Eco-Resorts Leading the Change',
        excerpt: 'Explore stunning carbon-neutral resorts in Costa Rica and Norway that prove eco-friendly travel does not mean sacrificing comfort.',
        category: 'Luxury Stays',
        image: 'https://images.unsplash.com/photo-1510798831971-661eb04b3739?auto=format&fit=crop&q=80&w=800',
        author: 'Sophia Reynolds',
        authorAvatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=200',
        date: 'Jul 14, 2026',
        readTime: '7 min read',
        views: '950'
      },
      {
        id: 6,
        title: 'Island Hopping in Greece: Best Apartments with Sea Views',
        excerpt: 'From Santorini sunrise suites to quiet beachside apartments in Naxos, here are top-rated rentals for an unforgettable summer.',
        category: 'Destination Guides',
        image: 'https://images.unsplash.com/photo-1533105079780-92b9be482077?auto=format&fit=crop&q=80&w=800',
        author: 'Julian Vance',
        authorAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200',
        date: 'Jul 09, 2026',
        readTime: '6 min read',
        views: '2.7k'
      },
      {
        id: 7,
        title: 'Smart Packing Essentials for Long-Stay Vacation Rentals',
        excerpt: 'Transform any apartment stay into a home away from home with this minimalist packing checklist designed for remote workers and slow travelers.',
        category: 'Travel Tips',
        image: 'https://images.unsplash.com/photo-1553531384-cc64ac80f931?auto=format&fit=crop&q=80&w=800',
        author: 'Elena Rostova',
        authorAvatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&q=80&w=200',
        date: 'Jul 02, 2026',
        readTime: '5 min read',
        views: '1.4k'
      }
    ];

    return (
      <div className="blog-list-page">
        {/* 1. Hero Banner */}
        <section className="blog-hero position-relative d-flex align-items-center justify-content-center text-center">
          <div className="hero-overlay"></div>
          <div className="container position-relative z-2 text-white">
            <span className="badge bg-white text-primary-blue px-3 py-2 rounded-pill fw-bold mb-3 shadow-sm text-uppercase tracking-wide">
              Bookly Travel Journal
            </span>
            <h1 className="display-4 fw-bold mb-3 animate-fade-up">Stories, Guides & Hospitality Insights</h1>
            <p className="lead mx-auto text-light opacity-90 animate-fade-up delay-1" style={{ maxWidth: '700px' }}>
              Inspiration for your next escape. Discover handpicked destination guides, insider booking advice, and luxury stay reviews.
            </p>
          </div>
        </section>

        {/* Main Content Section */}
        <section className="py-5 bg-light-gray">
          <div className="container py-4">
            
            {/* 2. Featured Post */}
            <div className="row mb-5">
              <div className="col-12">
                <div className="featured-card bg-white rounded-4 shadow-sm overflow-hidden border hover-lift">
                  <div className="row g-0">
                    <div className="col-lg-7 position-relative min-img-height">
                      <img 
                        src={featuredPost.image} 
                        alt={featuredPost.title} 
                        className="w-100 h-100 featured-img"
                      />
                      <span className="badge bg-primary-blue position-absolute top-0 start-0 m-4 px-3 py-2 rounded-pill fw-medium">
                        {featuredPost.category}
                      </span>
                    </div>
                    <div className="col-lg-5 p-4 p-md-5 d-flex flex-column justify-content-center">
                      <div className="d-flex align-items-center gap-2 text-muted small mb-3">
                        <i className="bi bi-star-fill text-warning"></i>
                        <span className="fw-bold text-dark-navy">Featured Article</span>
                        <span>•</span>
                        <span>{featuredPost.readTime}</span>
                      </div>
                      <h2 className="fw-bold text-dark-navy mb-3 display-6 fs-3 hover-text-blue">
                        <a href="/blog/details" className="text-decoration-none text-dark-navy">{featuredPost.title}</a>
                      </h2>
                      <p className="text-muted mb-4 line-height-md">{featuredPost.excerpt}</p>
                      <div className="d-flex align-items-center justify-content-between pt-3 border-top mt-auto">
                        <div className="d-flex align-items-center gap-3">
                          <img src={featuredPost.authorAvatar} alt={featuredPost.author} className="rounded-circle author-avatar" />
                          <div>
                            <span className="fw-bold text-dark-navy d-block small">{featuredPost.author}</span>
                            <span className="text-muted small">{featuredPost.date}</span>
                          </div>
                        </div>
                        <a href="/blog/details" className="btn btn-outline-primary rounded-pill px-4 btn-sm fw-bold">
                          Read Article <i className="bi bi-arrow-right ms-1"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 3. Search & Grid Layout */}
            <div className="row g-4">
              
              {/* Left Column: Blog Grid */}
              <div className="col-lg-8">
                
                {/* Active Filter Bar */}
                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                  <h4 className="fw-bold text-dark-navy mb-0">Latest Stories</h4>
                  <span className="text-muted small">Showing {blogPosts.length} articles</span>
                </div>

                <div className="row g-4">
                  {blogPosts.map((post) => (
                    <div key={post.id} className="col-md-6">
                      <div className="blog-card bg-white rounded-4 shadow-sm border h-100 d-flex flex-column hover-lift overflow-hidden">
                        <div className="card-img-wrapper position-relative">
                          <img src={post.image} alt={post.title} className="w-100 card-img" />
                          <span className="badge bg-white text-dark-navy shadow-sm position-absolute top-0 start-0 m-3 px-3 py-2 rounded-pill fw-bold small">
                            {post.category}
                          </span>
                        </div>
                        <div className="p-4 d-flex flex-column flex-grow-1">
                          <div className="d-flex align-items-center gap-2 text-muted small mb-2">
                            <span><i className="bi bi-calendar3 me-1"></i>{post.date}</span>
                            <span>•</span>
                            <span><i className="bi bi-clock me-1"></i>{post.readTime}</span>
                          </div>
                          <h5 className="fw-bold text-dark-navy mb-3 line-clamp-2 hover-text-blue">
                            <a href="/blog/details" className="text-decoration-none text-dark-navy">{post.title}</a>
                          </h5>
                          <p className="text-muted small mb-4 line-clamp-3 line-height-md">{post.excerpt}</p>
                          
                          <div className="d-flex align-items-center justify-content-between pt-3 border-top mt-auto">
                            <div className="d-flex align-items-center gap-2">
                              <img src={post.authorAvatar} alt={post.author} className="rounded-circle author-avatar-sm" />
                              <span className="fw-medium text-dark-navy small">{post.author}</span>
                            </div>
                            <a href="/blog/details" className="text-primary-blue fw-bold text-decoration-none small d-flex align-items-center gap-1">
                              Read <i className="bi bi-chevron-right fs-7"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Pagination */}
                <nav className="mt-5 d-flex justify-content-center">
                  <ul className="pagination gap-2">
                    <li className="page-item disabled">
                      <a className="page-item-link rounded-circle d-flex align-items-center justify-content-center" href="#!">
                        <i className="bi bi-chevron-left"></i>
                      </a>
                    </li>
                    <li className="page-item active"><a className="page-item-link rounded-circle d-flex align-items-center justify-content-center" href="#!">1</a></li>
                    <li className="page-item"><a className="page-item-link rounded-circle d-flex align-items-center justify-content-center" href="#!">2</a></li>
                    <li className="page-item"><a className="page-item-link rounded-circle d-flex align-items-center justify-content-center" href="#!">3</a></li>
                    <li className="page-item">
                      <a className="page-item-link rounded-circle d-flex align-items-center justify-content-center" href="#!">
                        <i className="bi bi-chevron-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>

              </div>

              {/* Right Column: Sidebar */}
              <div className="col-lg-4">
                <div className="sidebar-wrapper d-flex flex-column gap-4">
                  
                  {/* Search Widget */}
                  <div className="sidebar-widget p-4 bg-white rounded-4 shadow-sm border">
                    <h5 className="fw-bold text-dark-navy mb-3">Search Journal</h5>
                    <div className="input-group">
                      <input 
                        type="text" 
                        className="form-control border-end-0 py-2" 
                        placeholder="Search topics, places..." 
                        value={searchQuery}
                        onChange={this.handleSearchChange}
                      />
                      <button className="btn btn-primary px-3" type="button">
                        <i className="bi bi-search"></i>
                      </button>
                    </div>
                  </div>

                  {/* Categories Widget */}
                  <div className="sidebar-widget p-4 bg-white rounded-4 shadow-sm border">
                    <h5 className="fw-bold text-dark-navy mb-3">Categories</h5>
                    <div className="d-flex flex-column gap-2">
                      {categories.map((cat, idx) => (
                        <button 
                          key={idx} 
                          className={`btn text-start d-flex justify-content-between align-items-center p-2 rounded-3 border-0 ${selectedCategory === cat.name ? 'bg-primary-blue text-white fw-bold' : 'bg-light text-dark-navy hover-bg-gray'}`}
                          onClick={() => this.handleCategorySelect(cat.name)}
                        >
                          <span>{cat.name}</span>
                          <span className={`badge rounded-pill ${selectedCategory === cat.name ? 'bg-white text-primary-blue' : 'bg-white text-muted border'}`}>
                            {cat.count}
                          </span>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Popular Tags Widget */}
                  <div className="sidebar-widget p-4 bg-white rounded-4 shadow-sm border">
                    <h5 className="fw-bold text-dark-navy mb-3">Explore Tags</h5>
                    <div className="d-flex flex-wrap gap-2">
                      {popularTags.map((tag, idx) => (
                        <button 
                          key={idx} 
                          className={`btn btn-sm rounded-pill px-3 py-1 ${selectedTag === tag ? 'btn-primary' : 'btn-outline-secondary'}`}
                          onClick={() => this.handleTagSelect(tag)}
                        >
                          #{tag}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Sidebar Banner CTA */}
                  <div className="sidebar-banner p-4 rounded-4 text-white text-center position-relative overflow-hidden">
                    <div className="banner-overlay"></div>
                    <div className="position-relative z-2">
                      <i className="bi bi-house-heart fs-1 text-warning mb-2 d-block"></i>
                      <h4 className="fw-bold mb-2">Save 15% on Your Next Stay</h4>
                      <p className="small text-light opacity-90 mb-3">Book directly with Bookly for guaranteed best rates & flexible check-in.</p>
                      <a href="/search" className="btn btn-warning rounded-pill fw-bold px-4 py-2 text-dark-navy btn-sm">Explore Stays</a>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

        {/* 4. Newsletter Section */}
        <section className="blog-newsletter py-5 position-relative">
          <div className="container py-4 position-relative z-2">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center text-white">
                <i className="bi bi-envelope-paper fs-1 text-warning mb-3 d-block"></i>
                <h2 className="display-6 fw-bold mb-3">Get Travel Insights Delivered Weekly</h2>
                <p className="lead opacity-90 mb-4 fs-6">
                  Join 45,000+ travelers. Receive exclusive hotel discounts, curated itineraries, and early access to Bookly offers.
                </p>

                {subscribed ? (
                  <div className="alert alert-success rounded-pill p-3 fw-bold max-w-md mx-auto">
                    <i className="bi bi-check-circle-fill me-2"></i> You are subscribed! Check your inbox soon.
                  </div>
                ) : (
                  <form onSubmit={this.handleNewsletterSubmit} className="d-flex flex-column flex-sm-row gap-2 max-w-lg mx-auto">
                    <input 
                      type="email" 
                      className="form-control form-control-lg rounded-pill px-4 border-0 fs-6" 
                      placeholder="Enter your email address..." 
                      value={emailInput}
                      onChange={(e) => this.setState({ emailInput: e.target.value })}
                      required
                    />
                    <button type="submit" className="btn btn-warning btn-lg rounded-pill px-4 fw-bold text-dark-navy fs-6">
                      Subscribe
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
          <div className="newsletter-overlay"></div>
        </section>
      </div>
    );
  }
}

export default BlogList;

